<div [class]="class" [formGroup]="form">
  <mat-slide-toggle [formControlName]="name" color="primary">{{label}}</mat-slide-toggle>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
